import styled from '@emotion/styled'

const TooltipInfoWrapper = styled('div')`
	.tooltip-title {
		color: #f4f4f4;
		font-size: 0.875rem;
		padding-bottom: 4px;
	}

	.tooltip-section-title {
		padding-top: 4px;
		padding-bottom: 4px;
		font-weight: bold;
	}

	.tooltip-button {
		margin-right: 20px;
	}

	.tooltip-section-text {
		white-space: pre-line;
	}
`

export { TooltipInfoWrapper }
